<template>
  <!-- add playlist modal -->

  <b-modal id="addMp3PlaylistModal" centered hide-footer>
    <template #modal-title> Add New Playlist </template
    ><b-form @submit.prevent="onSubmit">
      <b-row class="mt-3">
        <b-col md="12">
          <b-form-group
            label="Playlist category title"
            label-for="playlist_title"
            :playlist_title="playlist_title"
          >
            <b-form-input
              id="playlist_title"
              v-model="playlist_title"
              :playlist_title="playlist_title"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="Playlist Description (optional)"
            label-for="playlist_description"
            :playlist_description="playlist_description"
          >
            <b-form-textarea
              id="playlist_description"
              v-model="playlist_description"
              :playlist_description="playlist_description"
              rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="Time duration"
            label-for="time_duration"
            :time_duration="time_duration"
            class="timeDurationDiv"
          >
            <b-form-input
              id="time_duration"
              type="number"
              min="1"
              v-model="time_duration"
              :time_duration="time_duration"
              required
            ></b-form-input>
          </b-form-group> </b-col></b-row
      ><b-row class="mt-4">
        <b-col>
          <b-button
            variant="doomyoga-primary"
            class="btn-doom-yoga-submit float-right"
            type="submit"
            v-if="!is_loading"
          >
            Save
          </b-button>
          <b-button
            type="button"
            disabled
            variant="doomyoga-primary"
            class="btn-doom-yoga-submit float-right"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: "AddMp3Playlist",
  data() {
    return {
      playlist_title: null,
      playlist_description: null,
      time_duration: null,
      is_loading: false,};
  },
  methods: {
    
    onSubmit(event) {
      console.log(event);
      console.log(this.playlist_title);
      console.log(this.playlist_description);
      console.log(this.time_duration);
      this.is_loading = true;

      console.log(this);
      this.is_loading = false;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/media/AddMp3Playlist.vue